import BaseApi from "../../../../services/Api";
import React, {useEffect, useState} from "react";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../../Layout/Button";
import style from "./style.module.css";



import { useSearchParams } from "react-router-dom";
import ModalContactSuitor from "../../ModalContactSuitor";
import Swal from "sweetalert2";

const INITIAL_DATA = {
  total: 0,
  current_page: 1,
  last_page: 1,
  first_page_url: "",
  last_page_url: "",
  next_page_url: "",
  prev_page_url: null,
  path: "",
  from: 1,
  to: 1,
  data: [],
};

const Adopt = ({
choiceAnimal, idAnimal, onBack, closeModal
}) => {
  const [isSaving, setSaving] = React.useState(false);
  const [isShow, setShowModal] = React.useState(false);
  const [name, setName] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [choice, setChoice] = React.useState('');
  const [animal_id, setAnimal_id] = React.useState('');

  const buildFormData = () =>{
    const formData = new FormData();
    if(name!="" && name!=undefined && name!="null"){
      
      formData.append("name", name)
    }
    if(address !="" && address!=undefined && address!="null"){

      formData.append("address", address)
    }
    if(phone !="" && phone!=undefined && phone!="null"){
    formData.append("phone", phone)}

    if(email !="" && email!=undefined && email!="null"){
        formData.append("email", email)}

    if(choiceAnimal !="" && choiceAnimal!=undefined && choiceAnimal!="null"){
        formData.append('choice', choiceAnimal)
    }
    if(idAnimal !="" && idAnimal!=undefined && idAnimal!="null"){
        formData.append('animal_id', idAnimal)
    }

    return formData
  }

  const formData = buildFormData();

  const submitData = () => {
    setSaving(true);

    
      BaseApi.post('/pretendenteEnvio', formData).then(res => {
        setSaving(false);
        setShowModal(false);
      }).then(() => {
        Swal.fire('Tudo Certo!',  "Os seus dados foram salvos com sucesso, entraremos em contato em breve", 'success');
        onBack()
        closeModal()

      }).catch(err => {
        Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || `${err?.response?.data?.message}`, 'error');
        setSaving(false);
      })
    
  }

  const handleClose = () => {
    setShowModal(false);
  }


  const requestData = () => { /*TIRAR */
    BaseApi.get(`/pretendente`).then(res => {
      let data = res.data;
      setName(data.name);
      setAddress(data.address);
      setPhone(data.phone);
      setEmail(data.email);
      setChoice(data.choice);
      setAnimal_id(data.animal_id);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      setShowModal(false);
    })
  }

  useEffect(() => {
    if(isShow) {
      requestData();
    } else {
      setName('');
      setAddress('');
      setPhone('');
      setEmail('');
      setChoice('');
      setAnimal_id('');
      setSaving(false);
    }
  }, [isShow])


return (    
    <>
        <Modal.Title className={style.title}>PREENCHA PARA PROSSEGUIR COM {choiceAnimal=="adopt" ? "A ADOÇÃO" : "O LAR TEMPORARIO"}</Modal.Title>
          
            <>
              <div className={`row ${style.inputs}`}>
                <div className="form-group mb-3">
                  <label htmlFor="name"></label> 
                  <input
                    type="text"
                    className={style.box}
                    id="name"
                    placeholder="NOME"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    
                    />
                </div>

                <div className="form-group mb-3">
                <label htmlFor="address"></label> 
                  <input
                    type="text"
                    className={style.box}
                    id="address"
                    placeholder="ENDEREÇO"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    
                    />
                </div>

                <div className="form-group mb-3">
                <label htmlFor="phone"></label> 
                  <input
                    type="phone"
                    className={style.box}
                    id="phone"
                    placeholder="TELEFONE"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    
                    />
                </div>

                <div className="form-group mb-3">
                <label htmlFor="email"></label> 
                  <input
                    type="email"
                    className={style.box}
                    id="email"
                    placeholder="EMAIL"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    
                    />
                </div>

              </div>
            </>
    

           
             
                <>
             <div className={style.buttonContainer}>

               <div className={style.borderbutton}>

                 <Button
                   loading={isSaving}
                   onClick={submitData}
                   className={style.button}
                 >
                   ENVIAR
                 </Button>

               </div>


                <div className={style.borderbutton}>
              <button
                className={style.button}
                onClick={onBack}
                >
                VOLTAR
              </button>
              </div>

              </div>
              
              </>
        </>
  );
}

export default Adopt;